export default {
	name: '项目开发环境',
	test: [ 'https?://localhost', 'https?://' ],
	BASE: 'http://192.168.14.74:8885/', //MA通用接口
	ZUKER: 'http://192.168.15.26:8082/', //租客相关接口
	DATA: 'http://192.168.15.56:8193/', //首页统计接口
	FACE2FACE: 'http://192.168.15.56:8101/', //面对面接口
	APPORTION: 'http://192.168.15.56:8195/', //结算中心-券分摊应用接口
	TASK: 'http://192.168.15.56:8432/', //下载中心
	ACTIVITY: 'http://192.168.14.74:8885/', //活动管理相关
	MP_API: 'http://192.168.14.130:8091', //小程序登录
	APP_ACTIVITY_SIGNUP: 'http://192.168.15.26:8198', //活动登记应用
};
